import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=warm%20abstract%20geometric%20composition%20with%20soft%20orange%20and%20gold%20gradients%2C%20flowing%20curves%2C%20minimalist%20modern%20design%2C%20clean%20and%20elegant%20background%2C%20no%20text%2C%20artistic%20atmosphere%2C%20light%20airy%20feel&width=1440&height=800&seq=hero-bg-91niu&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 mb-6 leading-tight">
          让优质资源
          <br />
          <span className="text-primary-400">触手可及</span>
        </h1>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          91牛是专业互联网服务平台，通过智能匹配、数据分析、团队协作等核心功能，
          <br className="hidden md:block" />
          为每一位用户提供高效便捷的资源与服务体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tutorial"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm transition-all cursor-pointer"
          >
            立即体验
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap border border-background-50/40 hover:border-background-50 text-background-50 font-medium px-8 py-3.5 rounded-full text-sm transition-all cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { num: '50万+', label: '注册用户' },
            { num: '99.9%', label: '服务可用率' },
            { num: '2000+', label: '合作企业' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                {stat.num}
              </div>
              <div className="text-xs md:text-sm text-background-100/70 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}